import { MonoTypeOperatorFunction, pipe } from 'rxjs';
import { filter, repeat, take } from 'rxjs/operators';

// Repeat source observable every given interval,
// and complete only when given completion condition is verified
export function repeatUntil<T>(
  completionCondition: (observable: T) => boolean,
  interval = 3000
): MonoTypeOperatorFunction<T> {
  return pipe(
    repeat({ delay: interval }),
    filter(completionCondition),
    take(1)
  );
}
